<template>
  <div class="border border-dark tsny_box-padding">
    <b-row class="mb-3">
      <b-col class="col-8">
        <h1>{{ course._id }}</h1>
      </b-col>
      <b-col class="col-4">
        <b-button class="tsny_button float-right" @click="deleteCourse"
          >- Delete Course</b-button
        >
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <edit-description
          v-model="course.description"
          :course-id="course._id"
        />
      </b-col>
      <b-col class="col-auto min-width">
        <h2 class="tsny_header">Practice Exams</h2>
        <p v-if="!course.practiceExams.length" class="tsny_text">
          This course currently has no practice exams. Head over to the Exams
          page and add some
        </p>
        <ul>
          <li v-for="exam in course.practiceExams" :key="exam.name">
            <span title="Edit Exam" class="tsny_icon" @click="editExam(exam)"
              >{{ exam.examName }} <i class="ml-2 fa fas fa-edit"
            /></span>
            <i
              class="ml-2 fa fas fa-clipboard tsny_icon"
              title="Edit Score Tables"
              @click="editScoreTables(exam)"
            />
            <i
              class="ml-2 fa fa-trash tsny_icon"
              title="Delete Exam"
              @click="deleteExam(exam)"
            />
          </li>
        </ul>
        <b-button @click="createExam">+ Create Exam</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h2 class="tsny_header">Course Resources</h2>
        <p v-if="!course.resources.length" class="tsny_text">
          This course doesn't have any resources yet
        </p>
        <ul class="tsny_resources-list">
          <li
            class="tsny_text"
            :key="resource._id"
            v-for="(resource, index) in course.resources"
          >
            <course-resource :resource="resource" />
            <i class="fas fa-trash tsny_icon" @click="deleteResource(index)" />
          </li>
        </ul>
        <b-button class="tsny_button" @click="addResource"
          >+ Add Resource</b-button
        >
      </b-col>
      <b-col class="col-auto min-width">
        <b-row>
          <b-col>
            <question-categories
              :course-id="course._id"
              :question-categories="course.questionCategories"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <create-exam-modal :course-id="course._id" />
    <delete-exam-modal
      :course-id="course._id"
      :exam-name="selectedExam ? selectedExam.examName : null"
    />
    <add-resource-modal :course-id="course._id" :resources="course.resources" />
    <delete-resource-modal
      :course-id="course._id"
      :resource-index="resourceIndex"
      :resources="course.resources"
    />
    <delete-course-modal :course-id="course._id" />
  </div>
</template>

<script>
import AddResourceModal from "./AddResourceModal";
import DeleteCourseModal from "./DeleteCourseModal";
import DeleteResourceModal from "./DeleteResourceModal";
import CourseResource from "./CourseResource";
import QuestionCategories from "./QuestionCategories/QuestionCategories";
import CreateExamModal from "../Exams/CreateExamModal";
import DeleteExamModal from "../Exams/DeleteExamModal";
import EditDescription from "./EditDescription";

export default {
  name: "EditCourse",
  components: {
    EditDescription,
    DeleteExamModal,
    CreateExamModal,
    QuestionCategories,
    CourseResource,
    DeleteResourceModal,
    DeleteCourseModal,
    AddResourceModal
  },
  props: {
    course: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      resourceIndex: null,
      selectedExam: null
    };
  },
  methods: {
    addResource: function() {
      this.$bvModal.show("addResourceModal");
    },
    deleteCourse: function() {
      this.$bvModal.show("deleteCourseModal");
    },
    createExam() {
      this.$bvModal.show("createExamModal");
    },
    editExam(exam) {
      this.$router.push({
        name: "ExamAdministration",
        params: {
          courseId: this.course._id,
          questionCategories: this.course.questionCategories,
          exam: exam
        }
      });
    },
    deleteExam(exam) {
      this.selectedExam = exam;
      this.$bvModal.show("deleteExamModal");
    },
    deleteResource: function(index) {
      let $comp = this;
      $comp.resourceIndex = index;
      $comp.$bvModal.show("deleteResourceModal");
    },
    editScoreTables(exam) {
      this.$router.push({
        name: "ScoreTables",
        params: {
          exam: exam,
          courseId: this.course._id
        }
      });
    }
  }
};
</script>

<style scoped>
.min-width {
  min-width: 450px;
}
</style>
